<template>
  <div
    class="search-tip-wrapper"
    v-show="value && (hotWords.length || histories.length)"
    @click.stop
  >
    <div class="search-tip">
      <div class="hotwords" v-if="hotWords.length">
        <div class="title">热门搜索</div>
        <ul class="hot-list">
          <li
            class="hot-item"
            v-for="item in hotWords"
            @click="select({ item, type: 'hot' })"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="history" v-if="histories.length">
        <div class="title title-history">历史记录</div>
        <ul class="history-list">
          <li
            class="history-item"
            v-for="item in histories"
            @click="select({ item, type: 'history' })"
          >
            {{ item.value }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      titleMap: {
        template: 'template',
        bg: 'background',
        word: 'text',
        role: 'character',
        visual: 'material',
        music: 'sound',
        scene: 'scene',
      },
      hotWords: [],
      histories: [],
    };
  },
  computed: {
    ...mapGetters({
      getChoosedResourceType: 'materialArea/getChoosedResourceType',
    }),
  },
  watch: {
    value(val) {
      if (val) {
        this.onTipShow();
      }
    },
  },
  created() {
    document.body.addEventListener('click', this.onBodyClicked);
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.onBodyClicked);
  },
  methods: {
    ...mapActions({
      getHotWords: 'resources/getHotWords',
    }),
    async onTipShow() {
      let type = this.titleMap[this.getChoosedResourceType.key];
      let list = await this.getHotWords({ type });
      this.hotWords = list || [];

      let arr = this.getUniqLocalData();
      this.storeLocalData(arr);
      this.histories = arr.slice(0, 5);
    },
    select({ item, type }) {
      this.$emit('select', { item, type });
      this.$emit('input', false);
      let arr = this.getUniqLocalData();
      this.storeLocalData(arr);
      if (type === 'hot') {
        this.$store.commit('tracking/setTrackingData', {
          keyword_type: '热门推荐词',
        });
      }
      if (type === 'history') {
        this.$store.commit('tracking/setTrackingData', {
          keyword_type: '历史词',
        });
      }
    },
    onBodyClicked() {
      this.$emit('input', false);
    },
    uniq(arr = []) {
      let list = [];
      arr.forEach((v) => {
        if (v && !list.find((item) => item.value === v.value)) {
          list.push(v);
        }
      });
      return list;
    },
    getUniqLocalData() {
      let arr = this.$util.localStorage.get('SEARCH_history_record') || [];
      arr = this.uniq(arr);
      return arr;
    },
    storeLocalData(arr = []) {
      if (arr.length > 20) {
        let data = JSON.stringify(arr.slice(0, 20));
        this.$util.localStorage.set('SEARCH_history_record', data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-tip-wrapper {
  position: relative;
  height: 0;
  width: 262px;
}
.search-tip {
  position: absolute;
  top: -12px;
  z-index: 999;
  width: 262px;
  // min-height: 255px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 8px 7px rgba(69, 70, 75, 0.1);
  border-radius: 4px;
}
.title {
  padding: 14px 13px 10px;
  border-bottom: 1px solid #f8f8f8;
  color: #9c9c9c;
  text-align: left;
  font-size: 12px;
}
.title-history {
  padding-top: 10px;
}
.hot-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 8px 10px 3px;
}
.hot-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 24px;
  color: #474261;
  margin-right: 4px;
  padding-left: 4px;
  padding-right: 4px;
  cursor: pointer;
  margin-bottom: 2px;
  &:hover {
    background: #f4f4f4;
  }
}
.history-list {
  padding-top: 8px;
}
.history-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 244px;
  height: 24px;
  color: #474261;
  padding-left: 4px;
  margin: auto;
  margin-bottom: 9px;
  cursor: pointer;
  &:hover {
    background: #f4f4f4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/searchTip.vue